/**
 * The public pages that have their own words (the product pages and the pricing page), by address.
 *
 * The words themselves are on the server (services/marketingContent.js): they go into the first response for search engines and
 * are served at /api/public/page for the client to draw. This is only the list of addresses the client has a route for and what each
 * is called in a link. `HomeCrawlerCopy.test.js` fails if it differs from the server's list.
 */

export const LANDING_GROUPS = [
  {
    label: 'Product',
    links: [
      ['/ai-recruiting-agent', 'AI recruiting agent'],
      ['/ai-voice-interview-software', 'AI voice interview software'],
      ['/resume-screening-software', 'Resume screening software'],
      ['/requisition-approval-workflow', 'Requisition approval workflow'],
      ['/offer-letter-esignature', 'Offer letter e-signature'],
      ['/vendor-submittal-portal', 'Vendor submittal portal'],
      ['/job-application-tracker', 'Job application tracker'],
      ['/resume-match-score', 'Resume match score'],
      ['/ai-practice-interview', 'AI practice interview'],
      ['/career-fairs-and-events', 'Career fairs and events'],
      ['/interview-as-a-service', 'Interview as a service'],
    ],
  },
  {
    label: 'Platform and trust',
    links: [
      ['/platform', 'The hiring platform'],
      ['/security', 'Security and trust'],
      ['/responsible-ai', 'Responsible AI'],
    ],
  },
  {
    label: 'Industries',
    links: [
      ['/industries/technology', 'Technology hiring'],
      ['/industries/financial-services', 'Financial services hiring'],
      ['/industries/healthcare', 'Healthcare and pharma hiring'],
      ['/industries/staffing-and-rpo', 'Staffing and RPO'],
      ['/industries/manufacturing', 'Manufacturing and industrial hiring'],
    ],
  },
  {
    label: 'Company',
    links: [
      ['/pricing', 'Pricing'],
      ['/about', 'About'],
    ],
  },
];

export const LANDING_LINKS = LANDING_GROUPS.flatMap((group) => group.links);

export const LANDING_PATHS = LANDING_LINKS.map(([path]) => path);
